import { Box, Flex, Text } from "@chakra-ui/react";
import { User } from "../../../types";

export function UserTags({ user }: { user: User }) {
  if (!user.is_admin && !user.is_supporter) {
    return null;
  }

  return (
    <Flex flexDirection="row" gap="8px">
      {user.is_admin && <AdminBadge />}
      {user.is_supporter && <SupporterBadge />}
    </Flex>
  );
}

export function AdminBadge() {
  return (
    <Box
      background="transparent"
      border="1px solid"
      borderColor="blaze.300"
      borderRadius="36px"
      padding="2px 8px"
    >
      <Text
        fontSize="12px"
        fontFamily="Roboto Mono"
        color="dune.dune"
        fontWeight="500"
        letterSpacing="0.5px"
        fontStyle="medium"
      >
        Admin
      </Text>
    </Box>
  );
}

export function SupporterBadge() {
  return (
    <Box
      background="transparent"
      border="1px solid"
      borderColor="neutral.500"
      borderRadius="4"
      padding="2px 8px"
    >
      <Text
        fontSize="12px"
        fontFamily="Roboto Mono"
        color="dune.dune"
        fontWeight="500"
        letterSpacing="0.5px"
        fontStyle="medium"
      >
        Supporter
      </Text>
    </Box>
  );
}
